// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typePickemSetupPreviewBody = {
  leagueKey: string;
  setup?: {
    scoringFormat: "standard" | "confidence";
    picksRequiredMode: "all" | "count";
    picksRequiredCount?: number | null;
    pickBasis: "moneyline" | "spread";
    tiebreaker: "none" | "totalPoints";
    tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
    winPoints: number;
    lossPoints: number;
    roundGrouping: "day" | "week";
    weekStartDay?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    endDateMode: "date" | "tbd";
  } | null;
};

export type typePickemSetupPreviewOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    defaults: {
      scoringFormat: "standard" | "confidence";
      picksRequiredMode: "all" | "count";
      picksRequiredCount?: number | null;
      pickBasis: "moneyline" | "spread";
      tiebreaker: "none" | "totalPoints";
      tiePolicy: "tieIsWin" | "tieIsLoss" | "tieIsVoid";
      winPoints: number;
      lossPoints: number;
      roundGrouping: "day" | "week";
      weekStartDay?: number | null;
      startDate?: string | null;
      endDate?: string | null;
      endDateMode: "date" | "tbd";
    };
    hasSpreads: boolean;
    rulesLines: string[];
    fieldErrors: { field: string; reason: string }[];
  };
};

export type typePickemSetupPreviewOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemSetupPreviewOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typePickemSetupPreviewOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaPickemSetupPreviewBody = {
  type: "object",
  properties: {
    leagueKey: { type: "string", maxLength: 3000, minLength: 1 },
    setup: {
      oneOf: [
        {
          type: "object",
          properties: {
            scoringFormat: { type: "string", enum: ["standard", "confidence"] },
            picksRequiredMode: { type: "string", enum: ["all", "count"] },
            picksRequiredCount: {
              oneOf: [{ type: "integer" }, { enum: [null] }],
            },
            pickBasis: { type: "string", enum: ["moneyline", "spread"] },
            tiebreaker: { type: "string", enum: ["none", "totalPoints"] },
            tiePolicy: {
              type: "string",
              enum: ["tieIsWin", "tieIsLoss", "tieIsVoid"],
            },
            winPoints: { type: "integer" },
            lossPoints: { type: "integer" },
            roundGrouping: { type: "string", enum: ["day", "week"] },
            weekStartDay: { oneOf: [{ type: "integer" }, { enum: [null] }] },
            startDate: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            endDate: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            endDateMode: { type: "string", enum: ["date", "tbd"] },
          },
          required: [
            "scoringFormat",
            "picksRequiredMode",
            "pickBasis",
            "tiebreaker",
            "tiePolicy",
            "winPoints",
            "lossPoints",
            "roundGrouping",
            "endDateMode",
          ],
        },
        { enum: [null] },
      ],
    },
  },
  required: ["leagueKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createPickemSetupPreview(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaPickemSetupPreviewBody);
  }

  return async function postPickemSetupPreview(
    payload: typePickemSetupPreviewBody,
  ): Promise<
    typePickemSetupPreviewOutput200 | typePickemSetupPreviewOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postPickemSetupPreview" failed before calling the network. #408a571bd78e`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#408a571bd78e" },
        },
        data: null,
      } as typePickemSetupPreviewOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/pickem/setup-preview`,
      httpMethod: "POST",
      options,
    })) as typePickemSetupPreviewOutput200 | typePickemSetupPreviewOutput400;
  };
}
